import { AssertState } from "../common/assert.js";
import { createShape, metadata } from "../common/mod.js";
export function instance(ctor, $args, toArgs) {
    return createShape({
        metadata: metadata("$.instance", instance, ctor, $args, toArgs),
        staticSize: $args.staticSize,
        subEncode(buffer, value) {
            $args.subEncode(buffer, toArgs(value));
        },
        subDecode(buffer) {
            return new ctor(...$args.subDecode(buffer));
        },
        subAssert(assert) {
            assert.instanceof(this, ctor);
            $args.subAssert(new AssertState(toArgs(assert.value), "#arguments", assert));
        },
    });
}
//# sourceMappingURL=instance.js.map